import styled from "styled-components";
import { pxToRem } from "../../styles/utils";

export const EditableTextarea = styled.textarea`
  width: 100%;
  font-size: ${pxToRem(18)};
  font-weight: 400;
  color: rgb(31, 10, 53);
  border: none;
  border-radius: ${pxToRem(8)};
  padding: ${pxToRem(8)} ${pxToRem(12)};
  outline: none;
  resize: none;
  background: none;
  overflow: hidden;
`;
